import React from 'react';
import WebView from 'react-native-webview'

const blog = () => {
    return <WebView source={{ uri: 'https://blog.gestaogma.com.br/' }} />;
}

export default blog;